const trackMetaEvent = (eventName, params = {}) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', eventName, params);
  } else {
    console.warn('Meta Pixel is not initialized.');
  }
};

export default trackMetaEvent;
